import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { CreateTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/token/create-token.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { TokenCreateFormStep1Controller } from '@app/feature/token/token-create/token-create-form-step-1/token-create-form-step-1.controller';
import { useCreateTokenContext } from '@app/feature/token/token.context';

interface TokenCreateFormControllerProps {
  onError: SubmitErrorHandler<CreateTokenModel>;
  onSubmit: SubmitHandlerWithDirtyFields<CreateTokenModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const TokenCreateFormController = (
  props: TokenCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useCreateTokenContext();

  return (
    <MultiStepFormProvider<CreateTokenModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: [
            'type',
            'expirationDate',
            'whitelist',
            'language',
            'networkId',
            'customerId',
            'chargePointId',
            'firstName',
            'lastName',
            'vehicle',
            'comment',
            'uid',
            'visualNumber',
          ],
          component: <TokenCreateFormStep1Controller />,
        },
      ]}
    />
  );
};
